const participantFieldMappings = [
  { field: 'participantName', displayName: 'Participant name' },
  { field: 'accountTypeDescription', displayName: 'Account type' },
  { field: 'status', displayName: 'Status' },
  { field: 'createdDate', displayName: 'Created date' },
  {
    field: 'initialInvestmentAmount',
    displayName: 'Initial investment amount',
  },
]
export default participantFieldMappings
